import { filterNames } from '../constants'

export const billingStatuses = [
  { value: 'pending', label: 'Pendiente' },
  { value: 'collected', label: 'Pagado' },
]
export const billingTypes = [
  { value: 'null', label: 'Todos' },
  { value: 'invoice', label: 'Factura' },
  { value: 'credit', label: 'Rectificativa' },
]

export const filterResetValues = {
  [filterNames.invoiceDates]: [
    { filter: filterNames.invoiceDateStart, value: null },
    { filter: filterNames.invoiceDateEnd, value: null },
  ],
  [filterNames.collectedDates]: [
    { filter: filterNames.collectedDateStart, value: null },
    { filter: filterNames.collectedDateEnd, value: null },
  ],
  [filterNames.status]: [{ filter: filterNames.status, value: [] }],
}
